<template>
  <div class="bj-section" style="padding-bottom: 200px">
    <div class="ubold-title" style="margin-bottom: 40px;">我的认证</div>
    <div class="bj-rows content-between bj-item">
      <div class="bj-rows">
        <span class="name">邮箱认证</span>
        <div class="label" style="color: #F85A36">({{ details.emailCount }})</div>
      </div>
      <Button class="bj-border-F85A36" to="/my/user/myEmail">查看</Button>
    </div>
    <div class="bj-rows content-between bj-item">
      <div class="bj-rows">
        <span class="name">个人认证</span>
        <div class="label" style="color: #F85A36">({{ details.sfzCount }})</div>
      </div>
      <Button class="bj-border-F85A36" to="/my/user/myPersonal">查看</Button>
    </div>
    <div class="bj-rows content-between bj-item">
      <div class="bj-rows">
        <span class="name">企业认证</span>
        <div class="label" style="color: #F85A36">({{ details.qyCount }})</div>
      </div>
      <Button class="bj-border-F85A36" to="/my/user/myEnterprise">查看</Button>
    </div>
  </div>
</template>

<script>
import { myCertification } from "api/user.js";
export default {
  name: "security",
  data() {
    return {
      details: {
        emailCount: 0,
        emailList: [],
        enterpriseIdentityCount: 0,
        enterpriseIdentityList: [],
        userIdentityCount: 0,
        userIdentityList: [],
      },
    };
  },
  created() {
    this.req_getInfo();
  },
  methods: {
    async req_getInfo() {
      try {
        const { code, data } = await myCertification();
        if (code === 200) {
          this.details = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bj-item{
  padding: 30px 28px;
  background-color: #28292C;
  border-radius: 6px;
  margin-top: 20px;
  &:first-child{
    margin-top: 0;
  }
  .icon{
    width: 16px;
    height: 20px;
  }
  .name{
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 45px;
    margin: 0 25px;
  }
  .label{
    font-size: 14px;
    font-weight: 400;
    color: #737577;
  }
  .btn{
    color: #F85A36;
    cursor: pointer;
    padding: 10px 20px;
  }
}
</style>
